import styles from '../../assets/styles/Inventory/ViewMore.module.scss';
import { EditModalContainer } from '../../containers';
import { amountFormatter } from '../../utils/utils';
import { MimaText, Modal } from '../../components';
import { MdModeEditOutline } from 'react-icons/md';
import { inventoryStore } from '../../stores';
import { observer } from 'mobx-react';
import React from 'react';

const ViewMore = ({ closeModal, goBack, newEditModal, createNewEditModal }) => {

	const { selectedProduct } = inventoryStore;

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			{!newEditModal ? (
				<div style={{ width: '38rem' }}>
					<MimaText variant="subtitleBold" align="center" mb={3}>
					Product type information
					</MimaText>
					<div className={styles.editIcon} onClick={createNewEditModal}>
						<MdModeEditOutline /> <span>Edit</span>
					</div>
					<MimaText labelTitle="Product Type" mb={1}>
						{' '}
						{selectedProduct?.name}{' '}
					</MimaText>
					<MimaText labelTitle="product type description" mb={1}>
						{' '}
						{selectedProduct?.description}{' '}
					</MimaText>
					<MimaText labelTitle="Unit of Measurement" mb={1}>
						{' '}
						{selectedProduct?.unitOfMeasurement}{' '}
					</MimaText>
					<MimaText labelTitle="Product type has vendor split enabled" mb={1}>
						{' '}
						{selectedProduct?.hasSplit ? "Has Split Payment" : "Doesn't have Split Payment"}{' '}
					</MimaText>
					{selectedProduct?.imageUrls?.length > 0 ? (
						<div style={{ width: "38rem", marginBottom: "1rem" }}>
							<MimaText variant="small" mb={0.5} color="var(--color-primary)">
								Images Added
							</MimaText>
							<div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
								{selectedProduct?.imageUrls?.map((x, i) => (
									<img src={x} key={i} alt='product' style={{ height: "10rem" }} />
								))}
							</div>

						</div>) : (
						<MimaText labelTitle="Images Added" mb={1}>
							NONE
						</MimaText>)}

					{/* <MimaText labelTitle="Timeline Within State Delivery" mb={2}>
						{selectedProduct?.delivery?.withinState?.earlyDelivery || 0} -{' '}
						{selectedProduct?.delivery?.withinState?.lateDelivery || 0} days
					</MimaText> */}
					{/* <MimaText labelTitle="Product Location" mb={2}>
						Country: {selectedProduct?.country || ''} <br></br>
						State: {selectedProduct?.state || ''}
					</MimaText> */}
					{/* <MimaText labelTitle="Timeline for Different StateS Delivery" mb={2}>
						{selectedProduct?.delivery?.differentState?.earlyDelivery || 0} -{' '}
						{selectedProduct?.delivery?.differentState?.lateDelivery || 0} days
					</MimaText> */}
					{/* <MimaText labelTitle="Timeline International Delivery" mb={2}>
						{selectedProduct?.delivery?.international?.earlyDelivery || 0} -{' '}
						{selectedProduct?.delivery?.international?.lateDelivery || 0} days
					</MimaText> */}

					{selectedProduct?.stocks?.length > 0 && (
						<MimaText align="center" variant="bodyBold" mb={2} mt={2}>
							Available Stock
						</MimaText>
					)}
					{selectedProduct?.stocks?.map(stock => (
						<div className={styles.variationsInModal}>
							<div className={styles.variationsInModal_grid}>
								<MimaText variant="small" labelTitle="Stock name" mb={1}>
									{stock?.title || ''}
								</MimaText>
								<MimaText variant="small" labelTitle="Stock(s)" mb={1}>
									{stock?.variations?.map(
										variant => `${variant?.type}: ${variant?.value} `
									) || ''}
								</MimaText>
							</div>

							<div className={styles.variationsInModal_grid}>
								{/* <MimaText variant="small" labelTitle="Cost Price">
									{amountFormatter(stock?.currencyCode).format(stock?.costPrice)}
								</MimaText> */}
								<MimaText variant="small" labelTitle="Selling Price">
									{amountFormatter(stock?.currencyCode).format(
										stock?.sellingPrice
									)}
								</MimaText>

								{stock?.sellingPriceEUR > 0 ? (
									<MimaText variant="small" labelTitle="Selling Price(EUR)">
										{amountFormatter('EUR').format(stock?.sellingPriceEUR)}
									</MimaText>
								) : ''}
								{stock?.sellingPriceGBP > 0 ? (
									<MimaText variant="small" labelTitle="Selling Price(GBP)">
										{amountFormatter('GBP').format(stock?.sellingPriceGBP)}
									</MimaText>
								) : ''}
								<MimaText variant="small" labelTitle="Stock condition">
									{stock?.productCondition}
								</MimaText>
								<MimaText variant="small" labelTitle="Quantity">
									{stock?.quantity}
								</MimaText>
								<MimaText variant="small" labelTitle="Status">
									{stock?.status}
								</MimaText>

							</div>
							<div >
								<MimaText mt={2} mb={1} variant="smallBold">
									Cost and Quantity breakdown
								</MimaText>
								{stock?.quantityTracker.map((unit, i) => (
									<div className={styles.variationsInModal_grid}>
										<MimaText variant="small" labelTitle={`Unit Cost price ${i + 1}`}>
											{amountFormatter(stock?.currencyCode).format(unit.costPrice)}
										</MimaText>
										<MimaText variant="small" labelTitle={`Unit Quantity ${i + 1}`}>
											{unit.quantity}
										</MimaText>

									</div>
								))}
							</div>
						</div>
					))}
					{selectedProduct?.hasSplit && (
						<>
							<MimaText align="center" variant="bodyBold" mb={2} mt={2}>
								Split Payment Information
							</MimaText>
							<MimaText labelTitle="Split Name" mb={2}>
								{selectedProduct?.split?.name || ''}
							</MimaText>
							<MimaText labelTitle="Split Type" mb={2}>
								{selectedProduct?.split?.type || ''}
							</MimaText>
							<MimaText labelTitle="Phone Number" mb={2}>
								{selectedProduct?.split?.phone || ''}
							</MimaText>
							<MimaText labelTitle="Email" mb={2}>
								{selectedProduct?.split?.email || ''}
							</MimaText>
							{/* <MimaText labelTitle="Split Percentage" mb={2}>
								{`${selectedProduct?.split?.percentage || '0'}%`}
							</MimaText> */}
							<MimaText labelTitle="Account Name" mb={2}>
								{selectedProduct?.split?.accountName || ''}
							</MimaText>
							<MimaText labelTitle="Account Number" mb={2}>
								{selectedProduct?.split?.accountNumber || ''}
							</MimaText>
							<MimaText labelTitle="Bank" mb={2}>
								{selectedProduct?.split?.bank || ''}
							</MimaText>
						</>
					)}
				</div>
			) : (
				<EditModalContainer closeModal={closeModal} goBack={goBack} />
			)}
		</Modal>
	);
};
export default observer(ViewMore);
